import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-static-dictionary-select-dialog',
  templateUrl: './static-dictionary-select-dialog.component.html',
  styleUrls: ['./static-dictionary-select-dialog.component.scss']
})
export class StaticDictionarySelectDialogComponent extends DialogContentBase implements OnInit {

  constructor( public dialog: DialogRef,
    private fb:UntypedFormBuilder) {   super(dialog);  }

  @Input() caption:string;
  @Input() staticDictionaryName:string;
  form: UntypedFormGroup;
  selectedId: number;
  
  ngOnInit(): void {
    this.form = this.getForm();
  }

  confirm(){
    const result = this.form.controls['selectedId'].value;
        this.dialog.close({ text: 'OK' , selectedId: result});
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  getForm( ) {
    return this.fb.group({
      selectedId: [this.selectedId, Validators.required],
    });
  }
}


